import styled from 'styled-components';

const Heading = styled.h1`
  padding-right: 10px;
`;

export default Heading;
